import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconSeat: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="seat">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1 5.84V4.5a1.6 1.6 0 0 0-1.6-1.6H7a1.6 1.6 0 0 0-1.6 1.6v1.983a1.6 1.6 0 0 0 2.23 1.471l1.5-.643a1.6 1.6 0 0 0 .97-1.47ZM8.9 4.5v1.34a.4.4 0 0 1-.242.368l-1.5.643a.4.4 0 0 1-.558-.368V4.5c0-.22.18-.4.4-.4h1.5c.221 0 .4.18.4.4ZM5.72 11.002A1.727 1.727 0 0 1 7.404 8.9c1.2 0 2.313.63 2.93 1.66l1.488 2.478a2.6 2.6 0 0 1-.018 2.705l4.547-.252a2.557 2.557 0 1 1 .142 5.109H9.702c-1.241 0-2.122-.918-2.281-1.971l-.007.001-1.695-7.628Zm4.993 4.214-.46.614-.38.02a2.728 2.728 0 0 0-1.69.711l-1.292-5.82a.527.527 0 0 1 .514-.641c.779 0 1.5.409 1.901 1.077l1.488 2.479a1.4 1.4 0 0 1-.08 1.56Zm7.097 2.498a1.357 1.357 0 0 0-1.391-1.025l-6.48.36a1.528 1.528 0 0 0-1.075.531c-.613.715-.104 1.82.838 1.82h6.792c.883 0 1.53-.83 1.316-1.686Z"
    />
  </Icon>
);
